import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--up",
  "use": "icon-arrow--up-usage",
  "viewBox": "0 0 11 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 11 6\" id=\"icon-arrow--up\"><path d=\"M.21 4.814a.651.651 0 0 0-.21.487C0 5.69.322 6 .732 6c.204 0 .39-.082.533-.217l4.241-4.11 4.23 4.11a.784.784 0 0 0 .532.217c.41 0 .732-.311.732-.699a.651.651 0 0 0-.21-.487L6.076.247A.813.813 0 0 0 5.5 0a.786.786 0 0 0-.57.247L.21 4.814Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol